{
	"title": "Servizio non disponibile (500)",
	"description": "Prova ad aggiornare questa pagina o controlla la tua connessione Internet. Se questo errore persiste, segnalalo come bug, in modo che possiamo intervenire.",
	"primaryButtonTitle": "Aggiorna la pagina",
	"secondaryButtonTitle": "Copia il registro errori",
	"errorLogCopiedMessage": "Registro errori copiato",
	"traceparentLabel": "Traceparent"
}
